var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-progress-linear',{attrs:{"color":"green","height":"12","buffer-value":_vm.attendance},model:{value:(_vm.completed),callback:function ($$v) {_vm.completed=$$v},expression:"completed"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }